import { render, staticRenderFns } from "./SocialCustomerService.vue?vue&type=template&id=4d7ee8f6&scoped=true&"
import script from "./SocialCustomerService.vue?vue&type=script&lang=js&"
export * from "./SocialCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ee8f6",
  null
  
)

export default component.exports